import React, { useEffect, useRef } from "react";
import Highcharts from "highcharts";
import { formatNumber } from "../../../utils/DefaultFunction";

import { PRIMARY_BG } from '../../../theme/brand';
const SixMonthTrend = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const months = Object.keys(data);

    // Extract unique channels
    const allChannels = new Set();
    months.forEach((month) => {
      data[month].forEach((item) => {
        allChannels.add(item.channel);
      });
    });

    // Fixed colors for channels
    const channelColors = {
      "WhatsApp": "#10b981",
      "SMS": "#3b82f6",
      "E-Mail": "#f59e0b",
      "Voice (IVR)": PRIMARY_BG,
      "Push Notification": "#ef4444",
      "In-App Notification": "#8b5cf6",
      "Channel-null": "#9e9e9e"
    };

    // Prepare series for each channel
    const series = Array.from(allChannels).map((channel) => {
      return {
        name: channel,
        data: months.map((month) => {
          const found = data[month].find((d) => d.channel === channel);
          return found ? found.count : 0;
        }),
        color: channelColors[channel] || "#000000",
        marker: {
          enabled: true,
          symbol: "circle",
          lineWidth: 2,
          lineColor: channelColors[channel] || "#000000",
          fillColor: "#ffffff" // ✅ white fill inside
        },
        connectNulls: true
      };
    });

    Highcharts.chart(chartRef.current, {
      chart: {
        type: "line",
        backgroundColor: "#FFFF",
        spacing: [10, 10, 15, 10]
      },
      title: {
        text: null
      },
      credits: {
        enabled: false
      },
      xAxis: {
        categories: months,
        gridLineWidth: 1,
        gridLineDashStyle: "Dot", // ✅ dotted grid
        tickmarkPlacement: "on",
        lineWidth: 0,
        gridLineColor: "#6b7280"
      },
      yAxis: {
        gridLineWidth: 1,
        title: {
          text: "Messages",
          align: "middle", 

        },
        gridLineDashStyle: "Dot",
        gridLineColor: "#6b7280"// ✅ dotted grid
      },
      tooltip: {
        shared: true,
        useHTML: true,
        formatter: function () {
          let tooltip = `<b>${this.x}</b><br/>`;
          this.points.forEach((point) => {
            tooltip += `
              <div style="margin:6px 0;">
                <span style="color:${point.series.color}">●</span> 
                <span style="color:${point.series.color};">${point.series.name}:</span> 
                <span style="color:${point.series.color};">${formatNumber(point.y)}</span>
              </div>`;
          });
          return tooltip;
        }
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          marker: { enabled: true },
          lineWidth: 2
        }
      },
      series
    });
  }, [data]);

  return (
    <div>
      <div ref={chartRef} />
    </div>
  );
};

export default SixMonthTrend;
